// extracted by mini-css-extract-plugin
export var hero = "hero-module--hero--1Ngwp";
export var effect_up = "hero-module--effect_up--Vb3KF";
export var effect_down = "hero-module--effect_down--6FoE9";
export var content = "hero-module--content--1AVHh";
export var hide_mobile = "hero-module--hide_mobile--1VFYg";
export var show_mobile = "hero-module--show_mobile--3DV0B";
export var highlight = "hero-module--highlight--3eWK9";
export var subtitle = "hero-module--subtitle--2cb5I";